import type { SVGProps } from 'react';

const SvgArrowUpFull = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2 8.33333L2.94 9.27333L6.66667 5.55333L6.66667 13.6667L8 13.6667L8 5.55333L11.72 9.28L12.6667 8.33333L7.33333 3L2 8.33333Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgArrowUpFull;
